import * as React from 'react';
import { WidgetInputType } from 'common/schema/widget/input/WidgetInputType';
import { getWidgetSubtype, IWidget } from 'common/schema/widget/Widget';
import { WidgetGraphicType } from 'common/schema/widget/graphic/WidgetGraphic';
import { FormWidgetInputTextView } from '../FormWidgetInputTextView';
import { FormWidgetInputNumericView } from '../FormWidgetInputNumericView';
import { FormWidgetInputCurrencyView } from '../FormWidgetInputCurrencyView';
import { FormWidgetInputEmailView } from '../FormWidgetInputEmailView';
import { FormWidgetInputSingleChoiceView } from '../FormWidgetInputSingleChoiceView';
import { FormWidgetInputMultipleChoiceView } from '../FormWidgetInputMultipleChoiceView';
import { FormWidgetInputDateIntervalView } from '../FormWidgetInputDateIntervalView';
import { FormWidgetInputDateView } from '../FormWidgetInputDateView';
import { FormWidgetInputFileView } from '../FormWidgetInputFileView';
import { FormWidgetInputBooleanView } from '../FormWidgetInputBooleanView';
import { FormWidgetGraphicSectionView } from '../FormWidgetGraphicSectionView';
import { FormWidgetGraphicTextView } from '../FormWidgetGraphicTextView';
import { FormWidgetGraphicInfoView } from '../FormWidgetGraphicInfoView';
import { WidgetDynamicType } from 'common/schema/widget/dynamic/WidgetDynamic';
import { FormWidgetDynamicFieldView } from '../FormWidgetDynamicFieldView';
import { FormWidgetInputRegionView } from '../FormWidgetInputRegionView';
import { FormWidgetInputListView } from '../FormWidgetInputListView';
import { assertNever } from 'server/utils/typings/assertNever';
import { useConditionalFormWidget } from 'client/components/schema/procedures/context/useConditionalFormWidget';
import { FormWidgetInputCaptchaView } from '../FormWidgetInputCaptchaView';
import { FormWidgetInputUploadSignedView } from '../FormWidgetInputUploadSignedView';
import { FormWidgetInputPreviewView } from '../FormWidgetInputPreviewView';
import { FormWidgetInputCascadeSelectView } from '../../repository/input-cascade-select/FormWidgetInputCascadeSelectView';
import { FormWidgetGraphicDividerView } from '../FormWidgetGraphicDividerView';
import { FormWidgetInputMultiPreferenceView } from '../../repository/input-multi-preference/FormWidgetInputMultiPreferenceView';
import { FormWidgetDynamicComputedFieldView } from '../../repository/dynamic-computed/FormWidgetDynamicComputedFieldView';

export interface FormWidgetSwitchProps {
  widget: IWidget;
}

/**
 * Ritorna il Form di configurazione del Widget in base al Sottotipo del Widget
 */
export function FormWidgetSwitch(props: FormWidgetSwitchProps) {
  // verifica della visualizzazione consizionale del widget
  const { visible } = useConditionalFormWidget(props.widget);
  if (!visible) return null;

  const WidgetComponent = getFormWidgetComponent(props.widget);
  return <WidgetComponent {...props} />;
}

/**
 * Funzione di ricerca del Sottotipo
 */
function getFormWidgetComponent(widget: IWidget) {
  const subtype = getWidgetSubtype(widget);

  switch (subtype) {
    // Widget Grafici
    case WidgetGraphicType.Text:
      return FormWidgetGraphicTextView;
    case WidgetGraphicType.Section:
      return FormWidgetGraphicSectionView;
    case WidgetGraphicType.Info:
      return FormWidgetGraphicInfoView;
    case WidgetGraphicType.Divider:
      return FormWidgetGraphicDividerView;

    // Widget Dinamici
    case WidgetDynamicType.Dynamic:
      return FormWidgetDynamicFieldView;
    case WidgetDynamicType.Computed:
      return FormWidgetDynamicComputedFieldView;

    // Widget di Input
    case WidgetInputType.Text:
      return FormWidgetInputTextView;
    case WidgetInputType.Numeric:
      return FormWidgetInputNumericView;
    case WidgetInputType.Email:
      return FormWidgetInputEmailView;
    case WidgetInputType.Currency:
      return FormWidgetInputCurrencyView;
    case WidgetInputType.SingleChoice:
      return FormWidgetInputSingleChoiceView;
    case WidgetInputType.MultipleChoice:
      return FormWidgetInputMultipleChoiceView;
    case WidgetInputType.Date:
      return FormWidgetInputDateView;
    case WidgetInputType.DateInterval:
      return FormWidgetInputDateIntervalView;
    // // case WidgetInputType.Address: return FormWidgetAddressView;
    case WidgetInputType.File:
      return FormWidgetInputFileView;
    case WidgetInputType.UploadSigned:
      return FormWidgetInputUploadSignedView;
    case WidgetInputType.Preview:
      return FormWidgetInputPreviewView;
    case WidgetInputType.List:
      return FormWidgetInputListView;
    case WidgetInputType.Boolean:
      return FormWidgetInputBooleanView;
    case WidgetInputType.Region:
      return FormWidgetInputRegionView;
    case WidgetInputType.Captcha:
      return FormWidgetInputCaptchaView;
    case WidgetInputType.CascadeSelect:
      return FormWidgetInputCascadeSelectView;
    case WidgetInputType.MultiPreference:
      return FormWidgetInputMultiPreferenceView;

    case undefined:
      throw new Error(`Widget non gestito`);

    default:
      assertNever(subtype);
  }
}
